import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    checkups: {},
    t8x: {},
    gs2: {}
  }),
  getters: {
    checkups: state => {
      const checkups = Object.values(state.checkups)
      console.log(checkups)
      checkups.sort((a, b) => {
        if (a.created_at < b.created_at) {
          return 1
        }
        if (a.created_at > b.created_at) {
          return -1
        }
        return 0
      })
      return checkups
    },
    t8xById: state => id => state.t8x[id],
    gs2ById: state => id => state.gs2[id],
    byId: state => id => state.checkups[id]
  },
  mutations: {
    set (
      state,
      {
        RecordNo,
        deviceType,
        userId,
        created_at,
        sections
      }
    ) {
      if (!state.checkups[RecordNo]) {
        Vue.set(state.checkups, RecordNo, {})
      }
      Vue.set(state.checkups[RecordNo], 'RecordNo', RecordNo)
      Vue.set(state.checkups[RecordNo], 'deviceType', deviceType)
      Vue.set(state.checkups[RecordNo], 'userId', userId)
      Vue.set(state.checkups[RecordNo], 'created_at', created_at)
      Vue.set(state.checkups[RecordNo], 'sections', sections)
    },
    reset (state) {
      state.checkups = {}
      state.t8x = {}
      state.gs2 = {}
    },
    setT8x (
      state,
      {
        MachineId,
        MacAddr,
        UnitNo,
        UnitName,
        doctor_id,
        DoctorName,
        RecordNo,
        MeasureTime,
        LoginType,
        DeviceType,
        Member,
        Height,
        Fat,
        MinFat,
        BloodPressure,
        Bo,
        PEEcg,
        Temperature,
        Whr,
        BloodSugar,
        Ua,
        Chol,
        BloodFat,
        ArteryAve,
        interview_id,
        userId
      }
    ) {
      if (!state.t8x[RecordNo]) {
        Vue.set(state.t8x, RecordNo, {})
      }
      Vue.set(state.t8x[RecordNo], 'MachineId', MachineId)
      Vue.set(state.t8x[RecordNo], 'MacAddr', MacAddr)
      Vue.set(state.t8x[RecordNo], 'UnitNo', UnitNo)
      Vue.set(state.t8x[RecordNo], 'UnitName', UnitName)
      Vue.set(state.t8x[RecordNo], 'doctor_id', doctor_id)
      Vue.set(state.t8x[RecordNo], 'DoctorName', DoctorName)
      Vue.set(state.t8x[RecordNo], 'RecordNo', RecordNo)
      Vue.set(state.t8x[RecordNo], 'MeasureTime', MeasureTime)
      Vue.set(state.t8x[RecordNo], 'LoginType', LoginType)
      Vue.set(state.t8x[RecordNo], 'DeviceType', DeviceType)
      Vue.set(state.t8x[RecordNo], 'Member', Member)
      Vue.set(state.t8x[RecordNo], 'Height', Height)
      Vue.set(state.t8x[RecordNo], 'Fat', Fat)
      Vue.set(state.t8x[RecordNo], 'MinFat', MinFat)
      Vue.set(state.t8x[RecordNo], 'BloodPressure', BloodPressure)
      Vue.set(state.t8x[RecordNo], 'Bo', Bo)
      Vue.set(state.t8x[RecordNo], 'PEEcg', PEEcg)
      Vue.set(state.t8x[RecordNo], 'Temperature', Temperature)
      Vue.set(state.t8x[RecordNo], 'Whr', Whr)
      Vue.set(state.t8x[RecordNo], 'BloodSugar', BloodSugar)
      Vue.set(state.t8x[RecordNo], 'Ua', Ua)
      Vue.set(state.t8x[RecordNo], 'Chol', Chol)
      Vue.set(state.t8x[RecordNo], 'BloodFat', BloodFat)
      Vue.set(state.t8x[RecordNo], 'ArteryAve', ArteryAve)
      Vue.set(state.t8x[RecordNo], 'interview_id', interview_id)
      Vue.set(state.t8x[RecordNo], 'userId', userId)
    },
    setGs2 (
      state,
      {
        MachineID,
        MacAddr,
        RecordNo,
        MeasureTime,
        DeviceType,
        Member,
        Height,
        BloodPressure,
        Bo,
        Temperature,
        Whr,
        BloodSugar,
        Ua,
        Chol,
        Urinalysis,
        Hb,
        Vision,
        Tooth,
        PEEcg,
        Ultrasonic,
        PsychologicalAssessment,
        created_at,
        UserID,
        interview_id
      }
    ) {
      if (!state.gs2[RecordNo]) {
        Vue.set(state.gs2, RecordNo, {})
      }
      Vue.set(state.gs2[RecordNo], 'MachineID', MachineID)
      Vue.set(state.gs2[RecordNo], 'MacAddr', MacAddr)
      Vue.set(state.gs2[RecordNo], 'RecordNo', RecordNo)
      Vue.set(state.gs2[RecordNo], 'MeasureTime', MeasureTime)
      Vue.set(state.gs2[RecordNo], 'DeviceType', DeviceType)
      Vue.set(state.gs2[RecordNo], 'Member', Member)
      Vue.set(state.gs2[RecordNo], 'Height', Height)
      Vue.set(state.gs2[RecordNo], 'BloodPressure', BloodPressure)
      Vue.set(state.gs2[RecordNo], 'Bo', Bo)
      Vue.set(state.gs2[RecordNo], 'Temperature', Temperature)
      Vue.set(state.gs2[RecordNo], 'Whr', Whr)
      Vue.set(state.gs2[RecordNo], 'BloodSugar', BloodSugar)
      Vue.set(state.gs2[RecordNo], 'Ua', Ua)
      Vue.set(state.gs2[RecordNo], 'Chol', Chol)
      Vue.set(state.gs2[RecordNo], 'Urinalysis', Urinalysis)
      Vue.set(state.gs2[RecordNo], 'Hb', Hb)
      Vue.set(state.gs2[RecordNo], 'Vision', Vision)
      Vue.set(state.gs2[RecordNo], 'Tooth', Tooth)
      Vue.set(state.gs2[RecordNo], 'PEEcg', PEEcg)
      Vue.set(state.gs2[RecordNo], 'Ultrasonic', Ultrasonic)
      Vue.set(state.gs2[RecordNo], 'PsychologicalAssessment', PsychologicalAssessment)
      Vue.set(state.gs2[RecordNo], 'created_at', created_at)
      Vue.set(state.gs2[RecordNo], 'UserID', UserID)
      Vue.set(state.gs2[RecordNo], 'interview_id', interview_id)
    }
  }
}
